export const isMobilePreferencesEnabled = () => {
  return true;
};
